// removed by extract-text-webpack-plugin
module.exports = {"Card":"n_97McMNOkw1tpKNiDP3a","Header":"_22dZAExuxON8zoJsn52SHj","Title":"_2t___ZYW1HZR_7OOdteK_d","TableWrap":"QGqbTwMopyGMREzAV1QMe","container-fluid":"_3S0IDgqBrhpWwxLrXihol_"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Projects/styles.module.css
// module id = 207
// module chunks = 0